import http from "../http-common";

class DeviceService {
    getRecentLocations(data) {
        return http.get("device/recent/locations", { params: data });
    }
    getLocationHistory(data) {
        return http.get("device/locations", { params: data });
    }
}

export default new DeviceService();